const defaultWebpushIcon = 'https://static.growlytics.in/web_push/icon.png'

export { defaultWebpushIcon }
